export default __webpack_public_path__ + "static/header-main-e82ebc67f1247b87662618c95c2dcb47.jpg";